import React from 'react';
import Select from 'react-select';

const customStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const customOption = ({ innerProps, label, data }) => {
    return (
        <div {...innerProps} className={`custom-mapping-dropdown`}>
            {data?.status === 'active' ? (
                <span className=''>
                    <i className='mdi mdi-circle font-size-10 sfgreen' /> {label}
                </span>
            ) : (
                <span className=''>
                    {data?.status !== '' && (
                        <i className='mdi mdi-circle font-size-10 sfred' />
                    )}{' '}
                    {label}
                </span>
            )}
        </div>
    );
};

const DropdownWithStatusIcons = ({ options, onChange, value }) => {
    return (
        <Select
            menuPortalTarget={document.body}
            styles={customStyles}
            options={options}
            onChange={onChange}
            placeholder='Select Email to Activate'
            value={value}
            components={{ Option: customOption }}
        />
    );
}

export default DropdownWithStatusIcons;
